import React, { FunctionComponent } from 'react';
import { FUWidgetBlockModel } from '../../../../services/content/articleBody/models/FUWidgetBlockModel';

type Props = {
    data: FUWidgetBlockModel['data'];
};

const S365_TO_FU_WIDGET_TYPE_MAP = {
    widgetMatchQuiz: 'match-quiz',
    widgetClassicQuiz: 'classic-quiz',
    widgetPolls: 'poll',
    widgetPersonalityQuiz: 'personality-quiz',
};

const defineWidgetAttributes = (widgetType: string, widgetData: any) => {
    let attributes: Record<string, string> = {
        'data-component': 'fu-widget',
        'data-content-type': widgetType,
        'data-content-id': widgetData.id,
        'data-lead-fields': 'email',
        'data-lead-position': 'before',
        'data-campaign-id': 'christmas-2025',
        'data-campaign-name': 'Christmas campaign 2025',
    };

    // TODO: Use after the problems on FansUnited's side are fixed
    // const leadFields = widgetData?.custom_fields?.lead;
    //
    // // NOTE: data-custom-fields can be used to pass custom lead fields to the widget, TBD in future data will be available in the custom_fields.
    // if (leadFields) {
    //     attributes['data-lead-fields'] = leadFields;
    //     attributes['data-lead-position'] = 'before';
    // }
    //
    // const context = widgetData?.context;
    //
    // if (context && context.campaign?.id && context.campaign?.label) {
    //     attributes['data-campaign-id'] = context.campaign.id;
    //     attributes['data-campaign-name'] = context.campaign.label;
    // }

    if (widgetType === S365_TO_FU_WIDGET_TYPE_MAP.widgetPersonalityQuiz) {
        return {
            ...attributes,
            'data-layout-template': 'SPLIT',
            'data-options-layout': 'column',
            'data-show-answer-explanations': 'true',
        };
    }

    return attributes;
};

export const FUWidgetBlock: FunctionComponent<Props> = ({ data }: Props) => {
    const widgetType = S365_TO_FU_WIDGET_TYPE_MAP[data?.widgetType?.trim() as keyof typeof S365_TO_FU_WIDGET_TYPE_MAP];

    if (!widgetType) {
        return null;
    }

    const widgetData = Object.values(data.widget)?.[0];

    if (!widgetData?.id) {
        return null;
    }

    return (
        <div className={`pb-4 pt-4`}>
            <div {...defineWidgetAttributes(widgetType, widgetData)}></div>
        </div>
    );
};

export default FUWidgetBlock;
